import { NgModule } from '@angular/core';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from '../component/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedComponentsModule } from '../../shared/module/shared-components.module';
import { LoginFormComponent } from '../component/login-form/login-form.component';
import { SetPhoneFormComponent } from '../component/set-phone-form/set-phone-form.component';
import { ForgotPasswordFormComponent } from '../component/forgot-password-form/forgot-password-form.component';
import { VerifySmsFormComponent } from '../component/verify-sms-form/verify-sms-form.component';
import { SetNewPasswordComponent } from '../component/set-new-password/set-new-password.component';
import { VerifyMethodComponent } from '../component/verify-sms-form/verify-method/verify-method.component';
import { MaintenanceComponent } from '../component/maintenance/maintenance.component';
import { TermsAndConditionsComponent } from '../component/terms-and-conditions/terms-and-conditions.component';
import { PasswordRulesComponent } from "../../shared/component/password-rules/password-rules.component";
import {
  PasswordStrengthMeterComponent,
} from "../../shared/component/password-strength-meter/password-strength-meter.component";
import { CaptchaComponent } from "../../shared/component/captcha/captcha.component";
import {
  InvisibleRecaptchaComponent,
} from "../../shared/component/captcha/invisible-recaptcha/invisible-recaptcha.component";
import { BoxModule } from "../../box/module/box.module";

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    SetPhoneFormComponent,
    ForgotPasswordFormComponent,
    VerifySmsFormComponent,
    SetNewPasswordComponent,
    VerifyMethodComponent,
    MaintenanceComponent,
    TermsAndConditionsComponent,
  ],
  imports: [
    LoginRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    PasswordRulesComponent,
    CaptchaComponent,
    InvisibleRecaptchaComponent,
    PasswordStrengthMeterComponent,
    BoxModule,
  ],
})
export class LoginModule {}
